export const Auth_Check = "Auth_Check";
export const file_Uploaddata = "fileUploaddata";
export const Step_Action = "Step_Action";
export const Refresh_Token = "Refresh_Token";
export const Customer_Config = "Customer_Config";
